"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusRecordStatus = exports.BonusSupportType = exports.BonusType = exports.BonusStatus = void 0;
/** 发财金的状态 */
var BonusStatus;
(function (BonusStatus) {
    /** 未领取 */
    BonusStatus["un_collect"] = "un_collect";
    /** 未使用 */
    BonusStatus["un_use"] = "un_use";
})(BonusStatus = exports.BonusStatus || (exports.BonusStatus = {}));
/** 发财金类型 */
var BonusType;
(function (BonusType) {
    BonusType[BonusType["BOT"] = 0] = "BOT";
    BonusType[BonusType["MANUAL"] = 1] = "MANUAL";
})(BonusType = exports.BonusType || (exports.BonusType = {}));
/** 发财金指定用途 */
var BonusSupportType;
(function (BonusSupportType) {
    /** 合约网格跟单 */
    BonusSupportType["copy_future_grid"] = "copy_future_grid";
    /** 合约网格大赛s8 */
    BonusSupportType["future_grid_competition_s8"] = "future_grid_competition_s8";
    /** 分仓合约开单 */
    BonusSupportType["open_futures_lite"] = "open_futures_lite";
})(BonusSupportType = exports.BonusSupportType || (exports.BonusSupportType = {}));
/** 发财金使用记录状态 */
var BonusRecordStatus;
(function (BonusRecordStatus) {
    /** 已使用 */
    BonusRecordStatus["used"] = "used";
    /** 已过期  */
    BonusRecordStatus["expired"] = "expired";
    /** 未领取已过期  */
    BonusRecordStatus["uncollect_expired"] = "uncollect_expired";
})(BonusRecordStatus = exports.BonusRecordStatus || (exports.BonusRecordStatus = {}));
